// extracted by mini-css-extract-plugin
export var growableInput = "_8v-0";
export var tagContainer = "_8v-2";
export var textInput = "_8v-1";